(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq-accordion"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('.custom-faq-accordion').forEach(function(section) {

    section.addEventListener('click', function(e) {

      var item = e.target.closest('details');

      if (!item || !section.contains(item)) return;

      section.querySelectorAll('details[open]').forEach(function(openItem) {

        if (openItem !== item) {
          openItem.removeAttribute('open');
        }

      });

    });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olc-numbered-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('olc-numbered-accordion')) {
    customElements.define('olc-numbered-accordion', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => {
          const summary = event.target.closest('summary');
          if (!summary || summary.closest('olc-numbered-accordion') !== this) return;
          if (!summary.parentElement.open && this.dataset.exclusive === 'true') {
            this.closeOthers(summary.parentElement);
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('details');
          if (!item || item.closest('olc-numbered-accordion') !== this) return;
          if (this.dataset.exclusive === 'true') this.closeOthers(item);
          item.open = true;
        }, options);
      }
      closeOthers(active) {
        this.querySelectorAll('.olc-numbered__item[open]').forEach((item) => {
          if (item !== active) item.open = false;
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
